export const SUBSCRIBE_MAIL_ENDPOINT = '/contact/subscribe';
